import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NotificacionServicio } from '@nucleo/notificaciones/notificacion-servicio';
import { IdiomaServicio } from '@nucleo/i18n/idioma-servicio';
import { IDIOMAS_DISPONIBLES, Idioma, NOMBRE_IDIOMA } from '@nucleo/i18n/idioma.enum';
import { DiccionarioIdiomas, textosActuales, traducciones } from '@nucleo/i18n/traduccion-util';
import { SesionApiServicio } from '@nucleo/sesion/sesion-api-servicio';

const TEXTOS_SELECTOR_IDIOMA: DiccionarioIdiomas<{
  etiqueta: string;
  noGuardado: string;
  noGuardadoDetalle: string;
}> = {
  es: {
    etiqueta: 'Idioma',
    noGuardado: 'Idioma no guardado',
    noGuardadoDetalle:
      'Cambiamos el idioma en este navegador, pero no pudimos guardarlo en tu cuenta. Inténtalo más tarde.',
  },
  en: {
    etiqueta: 'Language',
    noGuardado: 'Language not saved',
    noGuardadoDetalle:
      "We changed the language in this browser, but couldn't save it to your account. Try again later.",
  },
};

/**
 * Selector de idioma (ES / EN). Cambia toda la aplicación al instante y, con sesión, lo guarda en el usuario
 * (`PUT /account/language`) para que lo siga en cualquier equipo. Sin sesión (login) solo lo guarda en el navegador.
 */
@Component({
  selector: 'app-selector-idioma',
  templateUrl: './selector-idioma.html',
  styleUrl: './selector-idioma.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectorIdioma {
  private readonly servicioSesionApi = inject(SesionApiServicio);
  private readonly servicioToast = inject(NotificacionServicio);

  protected readonly idioma = inject(IdiomaServicio).idioma;
  protected readonly t = traducciones(TEXTOS_SELECTOR_IDIOMA);
  protected readonly idiomas = IDIOMAS_DISPONIBLES;
  protected readonly nombreIdioma = NOMBRE_IDIOMA;

  protected seleccionar(idioma: Idioma): void {
    if (idioma === this.idioma()) return;
    this.servicioSesionApi.cambiarIdioma(idioma).subscribe({
      error: () => {
        const textos = textosActuales(TEXTOS_SELECTOR_IDIOMA);
        this.servicioToast.advertencia(textos.noGuardado, textos.noGuardadoDetalle);
      },
    });
  }
}
